import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


const styles = {
  row: {
    display: 'flex',
    justifyContent: 'left',
  },
  avatar: {
    'margin-left': 10,
    'margin-right': 5,
  },
  bigAvatar: {
    'max-width': 60,
    'max-height': 40,
    height: 'auto',
    width: 'auto',
  },
};

function convertBrandToURL(brand) {
  switch (brand.toLowerCase()) {
    case 'bmw':
      return 'bmw.png';
    case 'toyota':
      return 'toyota.png';
    case 'honda':
      return 'honda.png';
    case 'ford':
      return 'ford.png';
    case 'lexus':
      return 'lexus.png';
    case 'chevrolet':
      return 'chevrolet.png';
    case 'audi':
      return 'audi.png';
    case 'acura':
      return 'acura.png';
    case 'landrover':
    case 'land rover':
      return 'land-rover.png';
    case 'alfa romeo':
      return 'alfa-romeo.png';
    default:
      return brand.toLowerCase() + '.png';
  }
}

function ImageAvatars(props) {
  const { classes, brand } = props;
    const imageSrc = 'https://s3.amazonaws.com/hipkar.com/car-logos/' + convertBrandToURL(brand)
  return (
    <div className={classes.row}>
      <img
        alt={brand}
        src={imageSrc}
        className={classes.bigAvatar}
      />
    </div>
  );
}

ImageAvatars.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImageAvatars);



// WEBPACK FOOTER //
// ./src/components/CarLogo.jsx